import { render, staticRenderFns } from "./AssessmentInterviewQuestionBoolean.vue?vue&type=template&id=78639d33&scoped=true&"
import script from "./AssessmentInterviewQuestionBoolean.vue?vue&type=script&lang=js&"
export * from "./AssessmentInterviewQuestionBoolean.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentInterviewQuestionBoolean.vue?vue&type=style&index=0&id=78639d33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78639d33",
  null
  
)

export default component.exports